import React from "react";
import Text from "@src/lib/ui/Text";
import { cn } from "@src/lib/utils/cn";

type Props = {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  className?: string;
};

const ClickableLinkText: React.FC<Props> = ({
  children,
  onClick,
  className = "",
}) => {
  return (
    <Text
      variant="compact-description"
      onClick={onClick}
      className={cn(
        "cursor-pointer rounded px-0.5 underline transition-colors hover:bg-gray-2",
        className,
      )}
    >
      {children}
    </Text>
  );
};

export default ClickableLinkText;
